export default __webpack_public_path__ + "static/hp-mobile-3412629964921365dabb624ec2699f34.png";